import React from 'react';
import { Container, Typography, Box, Paper, Grid } from '@mui/material';

const AboutPage = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Typography variant="h3" component="h1" align="center" gutterBottom>
        About Laprecio
      </Typography>
      
      <Paper sx={{ p: 4, mt: 4 }}>
        <Typography variant="h5" gutterBottom>
          Our Mission
        </Typography>
        <Typography variant="body1" paragraph>
          Laprecio is dedicated to transforming the mineral trading industry through technology, transparency, and trust. Our mission is to create a secure and efficient marketplace that connects all stakeholders in the mineral supply chain while ensuring compliance with international regulations and promoting sustainable practices.
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          Our Story
        </Typography>
        <Typography variant="body1" paragraph>
          Founded in 2023, Laprecio was born from the recognition that the mineral trading industry needed a modern, digital solution to address its challenges. Our team of industry experts and technology innovators came together to build a platform that would revolutionize how minerals are traded globally.
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          Our Values
        </Typography>
        <Grid container spacing={3} sx={{ mt: 2 }}>
          <Grid item xs={12} md={4}>
            <Box sx={{ textAlign: 'center', p: 2 }}>
              <Typography variant="h6" gutterBottom>
                Transparency
              </Typography>
              <Typography variant="body2">
                We believe in complete transparency throughout the mineral supply chain, from mine to market.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box sx={{ textAlign: 'center', p: 2 }}>
              <Typography variant="h6" gutterBottom>
                Security
              </Typography>
              <Typography variant="body2">
                We prioritize the security of transactions, data, and communications on our platform.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box sx={{ textAlign: 'center', p: 2 }}>
              <Typography variant="h6" gutterBottom>
                Sustainability
              </Typography>
              <Typography variant="body2">
                We are committed to promoting sustainable and ethical practices in the mineral industry.
              </Typography>
            </Box>
          </Grid>
        </Grid>
        
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          Our Team
        </Typography>
        <Typography variant="body1" paragraph>
          Laprecio is led by a team of experienced professionals with backgrounds in mineral trading, supply chain management, blockchain technology, and regulatory compliance. Our diverse expertise allows us to address the complex challenges of the mineral industry with innovative solutions.
        </Typography>
      </Paper>
    </Container>
  );
};

export default AboutPage;
